import { render, staticRenderFns } from "./NewInventoryReportPage.vue?vue&type=template&id=6022cb9c&scoped=true"
import script from "./NewInventoryReportPage.vue?vue&type=script&lang=js"
export * from "./NewInventoryReportPage.vue?vue&type=script&lang=js"
import style0 from "./NewInventoryReportPage.vue?vue&type=style&index=0&id=6022cb9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022cb9c",
  null
  
)

export default component.exports